'use client'

import React, { useCallback, useState } from 'react'

import type { HolidayFaqSection } from '@/src/types/holidays'
import useClevertapForHolidays from '@/src/hooks/analytics/clevertap/holidays'
import {
    HOLIDAY_ACTION,
    HOLIDAY_ACTION_TYPE,
    truncateHolidayText
} from '@/src/utils/analytics/holidays/holidayEvents'

import HolidayFaq from './holidayFaq'

interface HolidayFaqWrapperProps {
    section: HolidayFaqSection
    isMobile: boolean
}

const HolidayFaqWrapper: React.FC<HolidayFaqWrapperProps> = ({ section, isMobile }) => {
    const items = section.items ?? []
    const [expandedId, setExpandedId] = useState<string | null>(items[0]?.question ?? null)
    const { triggerHolidayUIActionEvent } = useClevertapForHolidays()

    // The question text is the id. Only an opening question is reported.
    const handleToggle = useCallback(
        (id: string) => {
            const isExpanding = expandedId !== id
            setExpandedId(isExpanding ? id : null)
            if (!isExpanding) return

            triggerHolidayUIActionEvent(HOLIDAY_ACTION.CONTENT_ENGAGED, {
                action_type: HOLIDAY_ACTION_TYPE.CONTENT,
                component: 'faq',
                engagement_type: 'expand',
                faq_index: items.findIndex(item => item.question === id) + 1,
                faq_question: truncateHolidayText(id)
            })
        },
        [expandedId, items, triggerHolidayUIActionEvent]
    )

    if (!items.length) return null

    return <HolidayFaq items={items} expandedId={expandedId} onToggle={handleToggle} isMobile={isMobile} />
}

export { HolidayFaqWrapper }
export default HolidayFaqWrapper
